const SPOILER_TYPE = "wix-rich-content-plugin-spoiler";

export { SPOILER_TYPE };
//# sourceMappingURL=types.js.map
